import LocationBaseController from '../common/location.base.controller'
import AppConstants from '../../../config/app.constants';

class ImportLocationsController extends LocationBaseController {
    /*@ngInject*/
    constructor(Auth, $state, User, LocationService, Modal, $translate, $stateParams, $http) {
        super(Auth, $state, User, LocationService, Modal, $translate, $stateParams)
        this.LocationService = LocationService;
        // this.Upload = Upload;

        this.$http = $http;
        this.model = {
            locationFile: "",
            locationData: []
        }
    }

    $onInit() {
    }

    uploadLocationData() {
        let locationData = [];
        const url = AppConstants.api + `/location/import-locations-data`;
        this.$http({
            url: url,
            method: "POST",
            data: {locations: this.model.locations},
            // headers: { 'Content-Type': undefined }
        }).then((response) => {
            this.model.locationData = response.data;
        });
    }

    uploadFile() {
        // debugger;
        // this.Upload.upload({
        //     url: AppConstants.api + `/location/import-locations`,
        //     data: {file: this.model.file},
        //     method: 'POST'
        // }).then(function (resp) {
        //     console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
        // }, function (resp) {
        //     console.log('Error status: ' + resp.status);
        // }, function (evt) {
        //     var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
        //     console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
        // });

        // this.Upload.http({
        //     url: AppConstants.api + `/location/import-locations`,
        //     headers : {
        //         'Content-Type': 'text/csv'
        //     },
        //     data: this.model.file
        // });

        // console.log(event.target.files);
        // console.log(event.target.files[0]);
        // var formData = new FormData();
        // formData.append('file', event.target.files);
        // console.log(formData)
        // this.$http({
        //     url: AppConstants.api + `/location/add-route-sequence`,
        //     method: "POST",
        //     data: formData,
        //     headers: {'Content-Type': undefined}
        // }).then(function (response) {
        //     console.log(response);
        // });

        // $http
        // .post(AppConstants.api + `/location/create`, data)
        // .then((res) => {
        //     return res.data
        // })
        // httpPostFactory('upload_image.php', formData, function (callback) {
        //    // recieve image name to use in a ng-src 
        //     console.log(callback);
        // });

        //         let testData = new FormData();
        // testData.append('file_upload', this.file, this.file.name);
        // console.log(event.target.files);
        // this.LocationService,importRouteSequence()
        // .then(() => {
        // 
        // })
        // .catch((err) => {
        // console.log(err);
        // })
    }

    reset() {
        this.model.locationFile = ""
    }
}

export default ImportLocationsController;



// WEBPACK FOOTER //
// ./client/app/components/location/import_locations/location.import_locations.controller.js